import { Injectable } from '@angular/core';
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import type { User } from "firebase/auth";
import { Observable, BehaviorSubject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private auth = getAuth(); // Inicializa o Firebase Authentication
  private _user$ = new BehaviorSubject<User | null>(null); // Observável para o usuário
  private _userIdToken$ = new BehaviorSubject<string | null>(null); // Observável para o token

  private _userToken: string | null = null;
  private _userId: string | null = null;
  private _currentUser: User | null = null;

  constructor() {
    // Listener para mudanças no estado de autenticação
    onAuthStateChanged(this.auth, async (user) => {
      this._user$.next(user);
      this._userId = user ? user.uid : null;

      if (user) {
        const token = await user.getIdToken();
        this._userIdToken$.next(token);
        //cuidar q o token expira
        this._userToken = token;
        this._currentUser = user;
      } else {
        this._userIdToken$.next(null);
        this._userToken = null;
      }
    });
  }

  // Observáveis com shareReplay
  public get user$(): Observable<User | null> {
    return this._user$.asObservable().pipe(shareReplay(1));
  }

  public get userIdToken$(): Observable<string | null> {
    return this._userIdToken$.asObservable().pipe(shareReplay(1));
  }

  // Propriedades para acesso direto
  get userToken(): string | null {
    return this._userToken;
  }

  get userId(): string | null {
    return this._userId;
  }

  set userId(value: string | null) {
    this._userId = value;
  }

  get currentUser(): User | null {
    return this._currentUser;
  }

  // Método para logout
  public async signOut() {
    await signOut(this.auth);
  }

  public logout() {
    this.auth.signOut();
  }

  public getAuth() {
    return this.auth;
  }
}
